import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DtoPoint from '../../dto/DtoPoint'
import DtoSource from '../../../administration/dto/DtoSource'
import { find } from 'lodash'
import { getDate } from '../../../utils/DateUtil'
import i18n from 'simple-react-i18n'

class SourcePanel extends Component {
	constructor(props) {
		super(props)
	}

	getSources = () => {
		if (this.props.point.sourceId) {
			const source = find(this.props.sources, (o) => {
				return o.id === this.props.point.sourceId
			})
			if (source) {
				return (
					<div className='row no-margin valign-wrapper '>
						<div className='col s8 no-padding'>
							{ i18n.source } : { source.name }
						</div>
						<div className='col s4 no-padding'>
							<a href={ source.url } target='_blank'>
								<img src={ source.logo } height={ '50' } />
							</a>
						</div>
					</div>
				)
			}
			return null
		}
		return null
	}


	getLastUpdate = () => {
		if (this.props.point.lastUpdate) {
			return getDate(this.props.point.lastUpdate)
		}
		return i18n.unknown
	}

	render() {
		return (
			<div className='row card'>
                <div className='card-padding'>
    				<div className='card-content no-padding'>
    					<div className='row no-margin valign-wrapper '>
    						<div className='col s6'>
    							<div className='row no-margin'>
    								<div className='col s12 no-padding'>
    									{ i18n.lastUpdate } : { this.getLastUpdate() }
    								</div>
    							</div>
    						</div>
    						<div className='col s6 right-align'>
    							{ this.getSources() }
    						</div>
    					</div>
    				</div>
    			</div>
			</div>
		)
	}
}

SourcePanel.propTypes = {
	point: PropTypes.objectOf(DtoPoint),
	sources: PropTypes.arrayOf(PropTypes.objectOf(DtoSource))
}

const mapStateToProps = store => {
	return {
		point: store.PointReducer.point,
		sources: store.AdministrationReducer.sources
	}
}

export default connect(mapStateToProps)(SourcePanel)



// WEBPACK FOOTER //
// ./src/point/components/source/SourcePanel.js